<script setup lang="ts">
  import { Button, ButtonVariant } from '@tundr/ds-components';
  import { useLocale } from '@tundr/i18n';
  import { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import { useSlideoverStore } from '../../store/slideover.store';
  import {
    closeSlideoverButtonClass,
    slideoverHeaderBodyClass,
    slideoverHeaderClass,
    slideoverHeaderTextClass,
    slideoverHeaderTitleClass,
  } from './SlideoverHeader.css';

  defineProps<{ title: string; body?: string }>();

  const { t } = useLocale();
  const slideoverStore = useSlideoverStore();
</script>

<template>
  <div :class="slideoverHeaderClass">
    <div :class="slideoverHeaderTextClass">
      <h2 id="slideover-title" :class="slideoverHeaderTitleClass">
        <slot>{{ title }}</slot>
      </h2>
      <p v-if="body || $slots.body" :class="slideoverHeaderBodyClass">
        <slot name="body">{{ body }}</slot>
      </p>
    </div>
    <Button
      :variant="ButtonVariant.Icon"
      is-ghost
      :class="closeSlideoverButtonClass"
      :icon-name="TUNDR_ICONS.CLOSE"
      :aria-label="t('common:actions.close')"
      @click="slideoverStore.closeSlideover()"
    />
  </div>
</template>
